export default __webpack_public_path__ + "8b18a77be77619201f1ac784790d3a24.ttf";